import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import PropTypes from 'prop-types';

import { notification } from 'antd';
import { useSelector } from 'react-redux';
import { CREATE_SCOPING_CRON_JOB, SAVE_AUDIT_LOGS } from '../../../services';
import CustomButton from '../../Button';
import CustomModal from '../../Modal';
import customTost from '../../Notification';
// import * as helper from '../../helper';

// get success message for pass/block list update
/* istanbul ignore next */
export const getSuccessMess = (str) => {
	return `The ${str} List updated successfully, and duplicate words (if any) have been removed to avoid errors.`;
};

/* istanbul ignore next */
const RedactionModal = (props) => {
	const {
		isModalOpen,
		setModelOpen,
		setLocLoading,
		setRedactionResult,
		initialValues,
		setInitialValues,
		newWords,
		deletedWords,
		fileWords,
		formValues,
		fileDetails,
		setCommitStatus,
		setClickedDeleteList,
		clickedDeleteList,
		clearAction,
		selectedList,
		setDeleteFileStatus,
	} = props;
	const { username } = useSelector((store) => store.storeProps);
	const cleaning = `${formValues.cleaning}`;
	const symspell__edit_distance = `${formValues.symspell__edit_distance}`;
	const values = { cleaning, symspell__edit_distance };
	const fileType = formValues?.redaction_type == 'Pass' ? 'Allow' : 'Block';
	const fileName =
		formValues?.filename?.indexOf('.txt') !== -1
			? formValues?.filename
			: `${fileType.toLowerCase()}-${formValues?.filename}.txt`;
	const allWords = [...newWords, ...fileWords];

	const updateElasticRecords = () => {
		try {
			const query = {
				query: {
					bool: {
						must: [
							{
								match: {
									is_masked: false,
								},
							},
							{
								range: {
									masking_attempts_left: {
										gte: 0,
									},
								},
							},
						],
						must_not: [
							{
								match: {
									scoping_done: false,
								},
							},
						],
					},
				},
				script: {
					source:
						'ctx._source.scoping_done=false;ctx._source.scope_regexes=null;ctx._source.scope_word_list=null',
					lang: 'painless',
				},
			};

			/* istanbul ignore next */
			setTimeout(() => {
				axios
					.post(`/api/update-elastic-records`, {
						query,
						index: 'event_logs',
					})
					.then((res) => {
						const vc = res?.data?.elRes?.meta?.body?.version_conflicts;
						if (vc > 0) {
							updateElasticRecords();
						}
					})
					.catch((err) => {
						console.error(err);
					});
			}, 10000);
		} catch (err) {
			console.error(err);
		}
	};

	const handlePegDeployment = async () => {
		try {
			setLocLoading(true);
			// update cleaning and sysmpell values in initalValues obj
			if (initialValues) {
				let newValues = {};
				let previousValues = {};

				// Compare function to get changed values
				initialValues.forEach((key) => {
					const valueToCompare =
						key === 'symspell__edit_distance'
							? initialValues[key] === 'true'
								? '1'
								: '0'
							: initialValues[key];

					if (values[key] !== undefined && values[key] !== valueToCompare) {
						newValues[key] = values[key];
						previousValues[key] = valueToCompare;
					}
				});

				const updatedVars = initialValues.map((obj) => {
					if (Object.hasOwn(values, obj.name)) {
						const newVal = {
							name: obj.name,
							value: values[obj.name],
						};

						return newVal;
					} else {
						return obj;
					}
				});

				const res = await axios.post(`/api/update-deployment-envars`, {
					updatedVars,
					flag: true,
				});
				const { data } = res;

				if (res.status === 200) {
					setInitialValues(updatedVars);
					SAVE_AUDIT_LOGS({
						action: 'update',
						newValues,
						previousValues,
						configType: 'Redaction Configuration',
						username,
					});
				} else {
					customTost({
						type: 'error',
						message: data?.message || 'Internal server error.',
					});
				}
			}
			const fileRes = await updateAndCreateFile();
			if (fileRes) {
				const oldScopeQueryString = fileDetails.find(
					(val) => val.filename == fileName,
				)?.scope_query_string;

				if (formValues.scope_query_string) {
					const wordFileUpdateStatus = await updateWordFile();
					if (wordFileUpdateStatus) {
						setCommitStatus(true);
					}
				} else {
					setCommitStatus(true);
				}

				let updatedValues = {
					scope_query_string: formValues.scope_query_string,
				};

				if (newWords.length || deletedWords.length) {
					updatedValues = {
						...updatedValues,
						add_words: newWords,
						remove_words: deletedWords,
					};
				}

				if (!formValues.download_file) {
					updatedValues = {
						...updatedValues,
						redaction_type: formValues.redaction_type,
						filename: fileName,
					};
				}

				SAVE_AUDIT_LOGS({
					action: formValues.download_file ? 'update' : 'create',
					newValues: updatedValues,
					previousValues:
						oldScopeQueryString === formValues.scope_query_string
							? null
							: { scope_query_string: oldScopeQueryString },
					configType: 'Words List Configuration',
					username,
				});

				customTost({
					type: 'success',
					message: getSuccessMess(fileName),
				});
			} else {
				customTost({
					type: 'error',
					message: 'Something went wrong.',
				});
			}
			setRedactionResult([]);
			setLocLoading(false);
		} catch (err) {
			setRedactionResult([]);
			setLocLoading(false);
			customTost({
				type: 'error',
				message: 'Internal server error.',
				// message: err?.response?.data?.message || 'Internal server error.',
			});
		}
	};

	const stopCreateScopeCron = async () => {
		try {
			const res = await axios.post(`/api/stop-create-scopecron`);
			return res;
		} catch (err) {
			notification.error({
				message: 'Something went wrong. Please try again later.',
			});
			CREATE_SCOPING_CRON_JOB();
			console.error(err);
			return null;
		}
	};

	const updateWordFile = () => {
		return new Promise((resolve, reject) => {
			const processFileDetails = async () => {
				let updatedFileDetails = [];
				const isAlreadyExist = fileDetails.find((val) => val.filename == fileName);
				const newFileDetail = {
					redaction_type: formValues.redaction_type,
					filename: fileName,
					original_filename: isAlreadyExist
						? isAlreadyExist?.original_filename
						: formValues?.filename,
					label: `${isAlreadyExist ? isAlreadyExist.label : `${fileType} ${formValues?.filename}`}`,
					scope_query: formValues.scope_query,
					scope_data: formValues.scope_data,
					scope_query_string: formValues.scope_query_string,
					file_status: true,
				};
				if (isAlreadyExist) {
					const updatedArray = fileDetails.map((val) => {
						if (val.filename == fileName) {
							return newFileDetail;
						} else {
							return val;
						}
					});
					updatedFileDetails = updatedArray;
				} else {
					updatedFileDetails = [...fileDetails, newFileDetail];
				}

				// save updated file details to minio
				const { data } = await axios.post('/api/save-minio-file', {
					fileName: 'words.json',
					fileDetails: JSON.stringify(updatedFileDetails),
					bucketName: 'dictionaries',
				});
				if (data.statusCode !== 200) {
					reject(false);
				}
				if (selectedList == 'New') {
					const res = await stopCreateScopeCron();
					if (res) {
						updateElasticRecords();
						resolve(true);
					}
				} else {
					resolve(true);
				}
			};

			processFileDetails().catch((err) => reject(err));
		});
	};

	const updateAndCreateFile = () => {
		return new Promise((resolve, reject) => {
			const updateFileDetails = async () => {
				if (deletedWords.length) {
					deletedWords.forEach((val) => {
						const valOfIndex = allWords.indexOf(val);
						if (valOfIndex !== -1) {
							allWords.splice(valOfIndex, 1);
						}
					});
				}
				let wordString = '';
				if (allWords.length) {
					wordString = allWords.join(' 1\n');
					wordString += ' 1';
				}
				// save updated file details to minio
				const { data } = await axios.post('/api/save-minio-file', {
					fileName,
					fileDetails: wordString,
					bucketName: 'dictionaries',
				});
				if (data.statusCode !== 200) {
					reject(false);
				} else {
					resolve(true);
				}
			};
			updateFileDetails().catch((err) => reject(err));
		});
	};

	const copyAndSaveMinioFile = async () => {
		try {
			const { data } = await axios.post('/api/copy-and-save-minio-file', {
				bucketName: 'dictionaries',
				destinationObject: `deleted-${selectedList}`,
				sourceObject: `/dictionaries/${selectedList}`,
			});
			if (data.statusCode === 200) {
				deleteFileFromMinio();
			}
		} catch (err) {
			console.error(err);
			customTost({
				type: 'error',
				message: 'Something went wrong.',
			});
			setDeleteFileStatus(false);
		}
	};

	const deleteFileFromMinio = async () => {
		try {
			const { data } = await axios.post('/api/delete-minio-file', {
				fileNameArray: [selectedList],
				bucketName: `dictionaries`,
			});
			if (data.statusCode === 200) {
				SAVE_AUDIT_LOGS({
					action: 'delete',
					newValues: null,
					previousValues: { deletedFile: selectedList },
					configType: 'Words List Configuration',
					username,
				});
				setDeleteFileStatus(false);
				setClickedDeleteList({ state: false, selectedList: '' });
				clearAction();
			}
		} catch (err) {
			console.error(err);
			customTost({
				type: 'error',
				message: 'Something went wrong.',
			});
			setDeleteFileStatus(false);
		}
	};

	const handleDeleteList = async () => {
		try {
			setDeleteFileStatus(true);
			const updatedFileDetails = fileDetails.map((val) => {
				if (val.filename === selectedList) {
					return { ...val, file_status: false };
				} else {
					return val;
				}
			});

			// save updated file details to minio
			const { data } = await axios.post('/api/save-minio-file', {
				fileName: 'words.json',
				fileDetails: JSON.stringify(updatedFileDetails),
				bucketName: 'dictionaries',
			});
			if (data.statusCode === 200) {
				copyAndSaveMinioFile();
			}
		} catch (err) {
			console.error(err);
			customTost({
				type: 'error',
				message: 'Something went wrong.',
			});
			setDeleteFileStatus(false);
		}
	};

	return (
		<>
			<CustomModal
				isOpen={isModalOpen}
				className='successModal modal_wrapper'
				onClose={() => setModelOpen(false)}
				footer={[
					<CustomButton onClick={() => setModelOpen(false)} key='btnClose' id='btnClose'>
						{'No, Cancel'}
					</CustomButton>,

					<CustomButton
						className='r-commit'
						onClick={() => {
							if (clickedDeleteList.state) {
								handleDeleteList();
							} else {
								handlePegDeployment();
							}

							setModelOpen(false);
						}}
						type='primary'
						key='btndownload'
					>
						{`Yes, ${clickedDeleteList.state ? 'Delete' : 'Commit'}`}
					</CustomButton>,
				]}
			>
				<div className='success_modal'>
					<ExclamationCircleOutlined style={{ color: '#FFCC00', fontSize: '50px' }} />
					<div className='success_modal_header'>Are you sure?</div>
					{!clickedDeleteList.state && (
						<div className='success_modal_sub'>
							All redaction changes will be saved and will be used in the next newly masked images.
						</div>
					)}
				</div>
			</CustomModal>
		</>
	);
};

RedactionModal.propTypes = {
	isModalOpen: PropTypes.bool,
	setModelOpen: PropTypes.func,
	form: PropTypes.any,
	setLocLoading: PropTypes.func,
	envars: PropTypes.object,
	passList: PropTypes.object,
	blockList: PropTypes.object,
	setRefetchList: PropTypes.func,
	clearPassLists: PropTypes.func,
	setRedactionResult: PropTypes.func,
	initialValues: PropTypes.any,
	setInitialValues: PropTypes.func,
	words: PropTypes.array,
	fileWords: PropTypes.array,
	formValues: PropTypes.any,
	fileDetails: PropTypes.any,
	setCommitStatus: PropTypes.func,
	setClickedDeleteList: PropTypes.func,
	clickedDeleteList: PropTypes.any,
	clearAction: PropTypes.func,
	selectedList: PropTypes.string,
	setDeleteFileStatus: PropTypes.func,
	newWords: PropTypes.array,
	deletedWords: PropTypes.array,
};

export default RedactionModal;
